// Api
const API = {
  backend: 'http://localhost:8080/api/v1',
  fastApi: 'https://api.stage.choosemuse.com/api/v1'
};

const CHARGEBEE = {
  site: 'choosemuse-test',
  publishableKey: 'test_FxgXzT5S1WjDRcdyuQlHAmuPA3ZggtOO5'
};

// Analytics
const ANALYTICS = {
  clevertapId: 'K95-RRR-WK5Z'
};

// Error tracking
const SENTRY = {
  DSN: 'https://09fd71ee6c7d4a23acc80bf5e2541a19@sentry.io/1240549',
  environment: 'Staging'
};

const CONNECT = {
  URL: 'http://localhost:8888/'
};

const MSWEB = {
  URL: 'https://www.meditationstudioapp.com'
};

const AUTH0 = {
  domain: 'login-staging.choosemuse.com',
  clientId: '2g5j4qHSe61QIaGengBMQksthLKK4wUW',
  audience: 'staging.choosemuse',
  connection: 'Username-Password-Authentication',
  configurationBaseUrl: 'https://cdn.auth0.com',
  namespace: 'https://ix.com'
};

const GTAG = {
  id: 'UA-129879028-1'
};

export default {
  API,
  AUTH0,
  ANALYTICS,
  CONNECT,
  MSWEB,
  SENTRY,
  CHARGEBEE,
  GTAG
};



// WEBPACK FOOTER //
// ./src/config/development.js